import React from "react";
import {ClientsContentBase} from "../ClientsContentBase";
import AgencyClientsList from "../agency/AgencyClientList";
import {Link} from "react-router-dom";
import {API_URL} from "../../settings/local_settings";
import { withTranslation } from 'react-i18next';


class UserClientsContentComponent extends ClientsContentBase {
    getClientsDataURL() {
        return API_URL + 'clients'
    }

    renderHeaderAndTabs(activeTab) {
        const { t } = this.props;
        return [
            <header className="section-header">
                <h1 className="section-title">{t('user_clients.management_title')}</h1>
            </header>,
            <div className="filters">
                <ul className={`tabs -first`}>
                    <li>
                        <Link className="tab-button" to={`/clients`}>Mis clientes</Link>
                    </li>
                </ul>
            </div>
        ]
    }

    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("second")}
                <div className="section-body h-items">
                    <AgencyClientsList doAgencyClientDelete={this.handleAgencyClientDelete}
                                       clients={this.state.clients}
                                       doClientStatusChange={this.handleAgencyClientStatusChange}
                                       afterSuccessfulAgencyClientSubmit={this.props.afterSuccessfulAgencyClientSubmit}
                                       myClientsMode={true}
                    />
                </div>
                {this.renderActivationModal()}
            </section>
        )
    }
}

export const UserClientsContent = withTranslation()(UserClientsContentComponent);
